<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
  import themeConfig from '@/../themeConfig.js'

  export default {
    watch: {
      '$store.state.theme'(val) {
        this.toggleClassInBody(val);
      }
    },
    async created() {
      window.GETCCMT = this;
      window.notification = null;
      window.chatNotification = null
      window.socket = null

      if (localStorage.getItem("userInfo") && localStorage.getItem("userInfo").length) {
        window.GETCCMT.$store.dispatch('updateUserInfo', JSON.parse(localStorage.getItem("userInfo")));
      }
    },
    methods: {
      toggleClassInBody(className) {
        if (className == 'dark') {
          if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark');
          document.body.classList.add('theme-dark');
        } else if (className == 'semi-dark') {
          if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark');
          document.body.classList.add('theme-semi-dark');
        } else {
          if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark');
          if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark');
        }
      },
      handleWindowResize(event) {
        this.$store.dispatch('updateWindowWidth', event.currentTarget.innerWidth);
      },
      return_text(error) {
        return error.message;
      },
      success(success, response) {
        this.$vs.loading.close()
        this.$vs.notify({
          time: 5000,
          title: 'Succès!',
          text: success,
          color: 'success',
          iconPack: 'feather',
          position: 'top-right',
          icon: 'icon-check-circle'
        })
        success = response // rein d'interressant
      },
      error(error) {
        this.$vs.loading.close()
        this.$vs.notify({
          time: 5000,
          title: 'Échec!',
          text: window.GETCCMT.return_text(error),
          color: 'danger',
          iconPack: 'feather',
          position: 'top-right',
          icon: 'icon-x-circle'
        })
      },
      notification(type, title, text){
        this.$vs.notify({
          time: 5000,
          title: title,
          text: text,
          color: type,
          iconPack: 'feather',
          position: 'top-right',
          icon: 'icon-x-circle'
        })
      }
    },
    mounted() {
      this.toggleClassInBody(themeConfig.theme)
      this.$nextTick(() => {
        window.addEventListener('resize', this.handleWindowResize);
      });
      this.$store.dispatch('updateWindowWidth', window.innerWidth);
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.handleWindowResize);
    },
  }

</script>
